<template>
  <span class="text-10 text-center rounded-[6.5px] min-w-[13px] px-[3.5px] shadow-[rgb(255_255_255)_0_0_0_2px]">
    <slot />
  </span>
</template>